import React, { useEffect, useState } from "react";
import styles from "./Footer.module.css";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "configs/AppConfig";

const ProductsServices = ({services}) => {
  const navigate = useNavigate();
  

  // const services = [
  //   {
  //     name: "Bodyshop Business Improvement Program",
  //     path: "/pages/business-improvement-program",
  //   },
  //   { name: "Bodyshop Health Checks", path: "/pages/bodyshop-health-checks" },
  //   {
  //     name: "Auto-retail After-sales Process Audits",
  //     path: "/pages/auto-retail-after-sales-process-audits",
  //   },
  //   {
  //     name: "Dealership Facility Design, Planning & Execution",
  //     path: "/pages/dealership-facility-design-planning&execution",
  //   },
  //   {
  //     name: "Auto Retail Management Software",
  //     path: "/pages/auto-retail-management-software",
  //   },
  //   {
  //     name: "Skill Enhancement Programs",
  //     path: "/pages/skill-enhancement-programs",
  //   },
  // ];


  return (
    <div className={styles.columnWrapper} data-aos="fade-right" data-aos-delay="200">
      <div className={styles.columnContent}>
        <div className={styles.columnHeader}>
          <h3 className={styles.columnHeading}>
            <div className={styles.columnHeadingWrapper}>
              <div className={styles.columnHeadingText}>
                Products & Services
              </div>
              <div className={styles.horizontalDivider} />
            </div>
            <div className={styles.columnHeadingUnderline} />
          </h3>
        </div>
        <ul className={styles.list}>
          {services?.map((service, index) => (
            <li
              onClick={() => navigate(service.path)}
              key={index}
              className={styles.listItem}
              style={{ cursor: "pointer" }}
            >
              <div>{service?.name}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProductsServices;
